module.exports = __webpack_public_path__ + "static/img/3.1fc2332.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/3.png
// module id = dUE+
// module chunks = 0